/*
 * Public API Surface of shared
 */

export * from './lib/extensions/extensions';
